"use strict";
var BaseViewModel = (function () {
    function BaseViewModel(options) {
        this.options = options;
        this.app = app;
        if (options) {
            if (options.successMessage) {
                app.f7.addNotification({ message: options.successMessage });
            }
            if (options.errorMessage) {
                app.f7.addNotification({ message: options.errorMessage });
            }
        }
    }
    BaseViewModel.prototype.redirectToPage = function (url) {
        window.location = url;
    };
    BaseViewModel.prototype.reloadPage = function () {
        window.location.reload();
    };
    return BaseViewModel;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BaseViewModel;
//# sourceMappingURL=baseViewModel.js.map